// authorization rules
import {GateCallbackFunction} from "core/parameters/ParametersManager";

export enum TENANTS_NAME {
  ADHR = 436
}

export enum GATE_NAME {
  PROJECT_REPORT_PDF = "projectReportPDF",
  PROJECT_REPORT_EXCEL = "projectReportExcel",
  PROJECT_CANDIDATES_EXCEL= "projectCandidatesExcel",
  SHOW_IED_META_FIELDS= "showIedMetaFields",
  CUSTOM_PROPOSAL_FIELD= "custom_proposal_field",
  PROJECT_EXPORT_EXCEL= "projectExportExcel",
  CV_EXPORT_EXCEL= "cvExportExcel",
  SHOW_CUSTOMER_CONTRACT= "showCustomerContract",
}

const gates: Map<GATE_NAME, GateCallbackFunction> =  new Map()



gates.set(GATE_NAME.PROJECT_REPORT_PDF, ({tenant}) => tenant.id === 2 || tenant.id === 60) // button only per CPL
gates.set(GATE_NAME.PROJECT_REPORT_EXCEL, ({settings}) => settings.excelCandidature > 0)
gates.set(GATE_NAME.PROJECT_EXPORT_EXCEL, ({settings, user, tenant}) =>  !settings.hideExport || (
  user.id === 6841 ||
  user.id === 22271 ||
  user.id === 24582 ||
  user.id === 60378 ||
    tenant.id === 436 // adhr
))

// export ProjectCandidatesExcel
gates.set(GATE_NAME.PROJECT_CANDIDATES_EXCEL, ({settings, tenant, user}) => {
  const NEURO_VENDITA = 177
  return !settings.hideExport ||
    (tenant.id === NEURO_VENDITA && user.role.includes("ROLE_ADMIN"))
})

gates.set(GATE_NAME.SHOW_IED_META_FIELDS, ({tenant}) => {
  return tenant.id === 310
})

gates.set(GATE_NAME.CUSTOM_PROPOSAL_FIELD, ({tenant}) => {
  return tenant.id === 310
})

gates.set(GATE_NAME.CV_EXPORT_EXCEL, ({settings, user, tenant}) =>  !settings.hideExport || (
  user.id === 6841 ||
  user.id === 22271 ||
  user.id === 24582 ||
  user.id === 60378 ||
  (tenant.id === TENANTS_NAME.ADHR && user.role.includes("ROLE_ADMIN"))
))

gates.set(GATE_NAME.SHOW_CUSTOMER_CONTRACT, ({tenant, user}) => {
  const customer = user?.customer
  return !customer?.contractDate && tenant?.id === 310
})

export default gates
